module.exports = __webpack_public_path__ + "img/layer83_2x.46eefc42.png";